import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ChevronRight } from 'lucide-react';

export default function Phase1ProjectInfo({ wizardData, setWizardData, onNext }) {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="projectName" className="text-lg font-semibold mb-2 block">What is the name of your project?</Label>
        <p className="text-sm text-slate-500 mb-4">Enter a descriptive name for your procurement project</p>
        <Input
          id="projectName"
          type="text"
          placeholder="e.g., School Building Renovation Project 2025"
          value={wizardData.projectName}
          onChange={(e) => setWizardData({ ...wizardData, projectName: e.target.value })}
          className="text-lg"
        />
      </div>
      <Button onClick={onNext} className="w-full bg-emerald-600 hover:bg-emerald-700" size="lg">
        Next <ChevronRight className="w-4 h-4 ml-2" />
      </Button>
    </div>
  );
}
